import React, { useEffect } from 'react';
import { Modal, Row, Col, Form } from 'antd';
import SelectKnowledgeArea from '../../Elements/Select-Knowledge-Area';
import SelectActorType from '../../Elements/Select-Actor-Type';
import { useSelector } from 'react-redux';

interface ModalSelectTopicsProps {
    visible: boolean;
    onCancel: () => void;
    onOk: (selectedTopics: string[]) => void;
}

const ModalSelectTopics: React.FC<ModalSelectTopicsProps> = ({ visible, onCancel, onOk }) => {
    const [form] = Form.useForm();
    const userState = useSelector((state: any) => state.user);

    useEffect(() => {
        console.log("me", userState.user.me.preferences);

        if (userState.user.me.preferences) {
            form.setFieldsValue({
                area_general: userState.user?.me?.preferences?.area_general?.map((obj: any) => ({
                    value: obj.value,
                    label: obj.label
                })),
                actor: {
                    value: userState.user?.me?.preferences?.actor?.map((obj: any) => ({
                        value: obj.value,
                        label: obj.label
                    }))
                },
            }); form.setFieldsValue({
                area_general: userState.user?.me?.preferences?.area_general?.map((obj: any) => ({
                    value: obj.value,
                    label: obj.label
                })),
                actor: userState.user?.me?.preferences?.actor?.map((obj: any) => ({
                    value: obj.value,
                    label: obj.label
                }))
            });
        }

    }, [form, userState.user.me.preferences, userState.user.me?.prerences?.actor, userState.user.me?.prerences?.area_general, userState.user.me.role.name]);


    return (
        <Modal
            title="Iniciaremos realizando una preguntas que nos permitirá adaptar y mejorar tu experiencia en la plataforma"
            width={700}
            open={visible}
            okText={'Continuar'}
            cancelText={'Omitir'}
            onCancel={onCancel}
            onOk={() => {
                onOk(form.getFieldsValue());
            }}
        >
            <br />
            <Form
                form={form}
                layout="vertical"
                onFinish={async (formData: any) => { }}>
                <Row gutter={16}>
                    <Col xs={24} sm={12} md={8} lg={24}>
                        <Form.Item
                            label="Por favor selecciona tus temas de interés. "
                            name="area_general"
                            rules={[
                                { type: 'array' },
                            ]}
                        >
                            <SelectKnowledgeArea
                                onClear={() => {

                                }}
                                mode={'multiple'}
                                style={{ width: '100%' }}
                                size="large"
                                onChange={(selected: any) => {
                                    console.log("area_general", selected);
                                    form.setFieldValue('area_general', selected);
                                }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={24}>
                        <Form.Item
                            label="Por favor selecciona que tipo de actor buscas."
                            name="actor"
                            rules={[
                                { type: 'array' },
                            ]}
                        >
                            <SelectActorType
                                mode={'multiple'}
                                onClear={() => {
                                }}
                                onChange={(selected: any) => {

                                    console.log("selected", selected);

                                    form.setFieldValue('actor', selected);
                                }} />
                        </Form.Item>

                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ModalSelectTopics;
